<template>
  <div class="detail-main">
    <vxe-grid
      ref="table"
      size="small"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
    >
      <template v-slot:widSlot="{ row }">
        {{ row.wid }} {{ row.widUnit }}
      </template>
      <template v-slot:weightSlot="{ row }">
        {{ row.fabricWeight }} {{ row.fabricWeightUnit }}
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from "@/mixins/table-auto-height";
import getTableColumns from "./table-columns.js";

export default {
  mixins: [TableAutoHeight],
  name: "DetailMain",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableColumn: getTableColumns(this),
    };
  },
  computed: {
    tableData() {
      return this.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-main {
  margin-top: 10px;
}
</style>
